import {
    FormikValues,
    useFormik
} from "formik";
import {
    Grid,
    Typography
} from "@mui/material";

import LocationSearchBox from "../../../componentsV2/location/LocationSearchBox";
import PropertySearchBox from "../../../componentsV2/property/PropertySearchBox";
import { BrandingSelector } from "../theme/brand/BrandingSelector";
import { get } from "lodash";

type ExternalReportVariablesFormProps<T extends FormikValues> = {
    formik: ReturnType<typeof useFormik<T>>;
};

export const ExternalReportVariablesForm = <T extends FormikValues>(props: ExternalReportVariablesFormProps<T>) => {
    const { formik } = props;

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h6">Configuration</Typography>
            </Grid>
            <Grid item xs={12}>
                <PropertySearchBox
                    name="variables.propertyId"
                    id="variables.propertyId"
                    label="Link to Property"
                    onClear={async () => {
                        await formik.setFieldValue("variables.propertyId", undefined);
                        await formik.setFieldValue("variables.propertyAddress", undefined);
                        await formik.validateForm()
                    }}
                    onSelect={async (property) => {
                        await formik.setFieldValue("variables.propertyId", property?.id);
                        await formik.setFieldValue("variables.propertyAddress", property?.address);
                        await formik.validateForm()
                    }}
                    initialPropertyId={formik.values.variables?.propertyId}
                    error={Boolean((formik.errors.variables as any)?.propertyId)}
                    helperText={(formik.errors.variables as any)?.propertyId}
                />
            </Grid>
            <Grid item xs={12}>
                <LocationSearchBox
                    name="variables.locationId"
                    id="variables.locationId"
                    propertyId={formik.values.variables?.propertyId}
                    label="Link to Location"
                    onClear={async () => {
                        await formik.setFieldValue("variables.locationId", undefined);
                        await formik.setFieldValue("variables.locationName", undefined);
                        await formik.setFieldValue("shouldCreateNewLocation", false);
                        await formik.validateForm()
                    }}
                    onSelect={async (location) => {
                        await formik.setFieldValue("variables.locationId", location?.id);
                        await formik.setFieldValue("variables.locationName", location?.name);
                        await formik.setFieldValue("shouldCreateNewLocation", false);
                        await formik.validateForm();
                    }}
                    disabled={formik.values.variables?.propertyId == undefined}
                    initialLocationId={formik.values.variables?.locationId}
                    error={Boolean((formik.errors.variables as any)?.locationId)}
                    helperText={(formik.errors.variables as any)?.locationId}
                    onNewOptionCreated={async (location) => {
                        await formik.setFieldValue('variables.locationName', location.name);
                        await formik.setFieldValue('shouldCreateNewLocation', true);
                    }}
                    locationName={get(formik.values.variables, 'locationName', '')}
                    isNewLocation={get(formik.values, 'shouldCreateNewLocation', false)}
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6">Branding</Typography>
            </Grid>
            <Grid item xs={12}>
                <BrandingSelector
                    formik={formik}
                />
            </Grid>
        </>
    );
};